import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import PreClearanceCategorieForm from '@app/components/apps/PreClearanceCategories/PreClearanceCategoryForm';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

export const ViewPreClearanceCategoryPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Pre-Clearance Category');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/pre-clearance-categories',
      breadcrumbName: 'Pre-Clearance Categories',
    },
    {
      path: '/view-pre-clearance-category',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <PreClearanceCategorieForm
            type="view"
            setCurrentBreadcrumName={setCurrentBreadcrumName}
            pageTitle={'View Pre-Clearance Category'}
            editable={false}
            id={id}
          />
        </Col>
      </Row>
    </>
  );
};

export default ViewPreClearanceCategoryPage;
